import { createSelector } from "reselect";
import { RootState } from "../../store/store";

export const selectUserProfile = createSelector(
  (state: RootState) => state.user.user,
  (user) => user,
);

export const selectIsLoggedIn = (state: RootState) => !!state.user.token;

export const selectIsLoadingUser = (state: RootState) => state.user.loading;
export const selectIsUserLoaded = (state: RootState) => state.user.loaded;

export const selectUserPlanUsage = (state: RootState) =>
  state.user.user?.usage || { analyzerLookupsUsed: 0 };

export const selectAmazonAccount = (state: RootState) =>
  state.user.amazonAccount;

export const selectPromos = (state: RootState) => ({
  growthMonthStarterPromo: state.user.user?.growthMonthStarterPromo ?? false,
  growthAnnualOneTimePromo: state.user.user?.growthAnnualOneTimePromo ?? false,
});
